import { Component, inject } from "@angular/core";
import { PageComponent } from "@tytapp/common";
import { UserService } from "@tytapp/user";
import { ApiPoll, ApiTopicGroupedPoll, ApiUser, PollsApi } from '@tytapp/api';


@Component({
    selector: 'tyt-petition-list',
    templateUrl: './petition-list.component.html',
    styleUrls: ['./petition-list.component.scss']
})
export class PetitionListComponent extends PageComponent {
    //#region Dependencies

    private userService = inject(UserService);
    private pollsApi = inject(PollsApi);

    //#endregion
    //#region Template Properties

    state: 'loading' | 'ready' = 'loading';
    user: ApiUser;
    petitions: ApiPoll[];
    groupedPetitions: ApiTopicGroupedPoll[];

    featuredLimit: number;

    //#endregion
    //#region Lifecycle

    async init() {
        this.pageTitle = `Campaigns`;

        this.subscribe(this.userService.userChanged, user => {
            this.user = user;
        });
        await this.fetchPetitions();
    }

    //#endregion
    //#region Logic

    async fetchPetitions() {
        this.petitions = null;
        this.petitions = await this.pollsApi.all('all', 'Petition', undefined, 1).toPromise();
        this.petitions = this.petitions.filter(({ topic }) => !topic);

        const grouped = await this.pollsApi.allGroupedByTopic().toPromise();

        const featured = grouped.filter(item => item.polls.length > 1);
        const rest = grouped.filter(item => item.polls.length <= 1);

        const pairs = Math.min(featured.length, rest.length);
        this.groupedPetitions = [];

        for (let i = 0; i < pairs; i++) {
            if (i & 1) {
                this.groupedPetitions.push(rest[i], featured[i]);
            } else {
                this.groupedPetitions.push(featured[i], rest[i]);
            }
        }
        this.groupedPetitions.push(...featured.slice(pairs), ...rest.slice(pairs));
        this.featuredLimit = pairs * 2 + 1;
    }

    isFeatured(group: ApiTopicGroupedPoll, index: number) {
        return group.polls?.length > 1 && index < this.featuredLimit;
    }
}
